import icon0 from '../assets/tileIcons/icon0.png';
import icon1 from '../assets/tileIcons/icon1.png';
import icon2 from '../assets/tileIcons/icon2.png';
import icon3 from '../assets/tileIcons/icon3.png';
import icon4 from '../assets/tileIcons/icon4.png';
import icon5 from '../assets/tileIcons/icon5.png';
import icon6 from '../assets/tileIcons/icon6.png';
import icon7 from '../assets/tileIcons/icon7.png';
import icon8 from '../assets/tileIcons/icon8.png';
import icon9 from '../assets/tileIcons/icon9.png';
import icon10 from '../assets/tileIcons/icon10.png';
import icon11 from '../assets/tileIcons/icon11.png';
import icon12 from '../assets/tileIcons/icon12.png';
import icon13 from '../assets/tileIcons/icon13.png';
import icon14 from '../assets/tileIcons/icon14.png';
import icon15 from '../assets/tileIcons/icon15.png';
import icon16 from '../assets/tileIcons/icon16.png';
import icon17 from '../assets/tileIcons/icon17.png';
import icon18 from '../assets/tileIcons/icon18.png';
import icon19 from '../assets/tileIcons/icon19.png';
import icon20 from '../assets/tileIcons/icon20.png';
import icon21 from '../assets/tileIcons/icon21.png';
import icon22 from '../assets/tileIcons/icon22.png';
import icon23 from '../assets/tileIcons/icon23.png';
import icon24 from '../assets/tileIcons/icon24.png';
import icon25 from '../assets/tileIcons/icon25.png';

export const FILTER_TABS = [
    {
        id: 'all',
        value: 'All'
    },
    {
        id: 'info',
        value: 'Info'
    },
    {
        id: 'tools',
        value: 'Tools'
    },
    {
        id: 'study',
        value: 'Study'
    },
    {
        id: 'custom',
        value: 'Custom'
    }
]

export const TILES = [
    {
        class: 'info',
        title: 'Time Tracking',
        imageIndex: 0,
        href: 'https://timewriting.brimit.com/'
    },
    {
        class: 'info',
        title: 'HR Policies',
        imageIndex: 2,
        href: '#'
    },
    {
        class: 'info',
        title: 'Reports',
        imageIndex: 3,
        href: '#'
    },
    {
        class: 'info',
        title: 'IT Assistance',
        imageIndex: 4,
        href: '#'
    },
    {
        class: 'info',
        title: 'Sitecore Resources',
        imageIndex: 5,
        href: '#'
    },
    {
        class: 'info',
        title: 'HR Policies',
        imageIndex: 2,
        href: '#'
    },
    {
        class: 'info',
        title: 'Reports',
        imageIndex: 0,
        href: '#'
    },
    {
        class: 'info',
        title: 'IT Assistance',
        imageIndex: 4,
        href: '#'
    },
    {
        class: 'tools',
        title: 'Welcome Book',
        imageIndex: 2,
        href: '#'
    },
    {
        class: 'tools',
        title: 'Invoicing App',
        imageIndex: 3,
        href: '#'
    },
    {
        class: 'tools',
        title: 'Perfomance Review',
        imageIndex: 4,
        href: '#'
    },
    {
        class: 'study',
        title: 'Employee CV',
        imageIndex: 0,
        href: '#'
    },
    {
        class: 'study',
        title: 'Employee Contacts',
        imageIndex: 4,
        href: '#'
    }
]

export const NOTIFICATIONS = [
    {
        message: 'Fill in your timesheet!',
        href: '/#'
    },
    {
        message: 'Do something!',
        href: '/#'
    },
    {
        message: 'Do something else!',
        href: '/#'
    }
]

export const TILES_ICONS = [ icon0, icon1, icon2, icon3, icon4, icon5, icon6, icon7, icon8, icon9, icon10, icon11, icon12, icon13, icon14, icon15, icon16, icon17, icon18, icon19, icon20, icon21, icon22, icon23, icon24, icon25 ];